'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = new _immutable.Map();

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.GET_MESSAGES_SUCCEEDED, function (state, action) {
  return action.payload;
}), _defineProperty(_handleActions, ActionTypes.CREATE_MESSAGE_SUCCEEDED, function (state, action) {
  var id = '' + action.payload.response.id;
  return state.set(id, action.payload.response);
}), _defineProperty(_handleActions, ActionTypes.DELETE_MESSAGE_SUCCEEDED, function (state, action) {
  var id = '' + action.payload.id;
  return state.delete(id);
}), _defineProperty(_handleActions, ActionTypes.UPDATE_MESSAGE_SUCCEEDED, function (state, action) {
  var message = action.payload.messageData;
  return state.set('' + message.id, message);
}), _defineProperty(_handleActions, ActionTypes.TOGGLE_MESSAGE_STATUS, function (state, action) {
  var id = '' + action.payload.id;

  var _state$get = state.get(id),
      active = _state$get.active;

  return state.setIn([id, 'active'], !active);
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/messages/reducers/messages.js
// module id = 1278
// module chunks = 3